import React from 'react';
import { Map } from 'immutable';
import { StatusBadge as UIBadge } from '@kineticdata/ui';

export const STATUS_COLORS = Map({
  default: {
    Running: 'primary',
    Active: 'success',
    Complete: 'success',
    Closed: 'danger',
    Created: 'warning',
    Pending: 'warning',
  },
});

export const getStatusColor = (value, type) =>
  STATUS_COLORS.getIn(
    [type || 'default', value],
    type ? STATUS_COLORS.getIn(['default', value], 'primary') : 'primary',
  );

export const StatusBadge = ({
  value,
  type,
  color = getStatusColor(value, type),
  ...props
}) => {
  return <UIBadge value={value} type={type} color={color} {...props} />;
};
